module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('blockquote', [_c('blockquote', [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Now the day is over,"), _c('br'), _vm._v("Night is drawing nigh;"), _c('br'), _vm._v("Shadows of the evening"), _c('br'), _vm._v("Steal across the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("      —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SABINE BARING-GOULD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('blockquote', [_c('blockquote', [_c('p', {
    staticClass: "para"
  }, [_vm._v("History . . . is indeed little more than"), _c('br'), _vm._v("the register of the crimes, follies, and"), _c('br'), _vm._v("misfortunes of mankind.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("         —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDWARD GIBBON")])])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('blockquote', [_c('blockquote', [_c('p', {
    staticClass: "para"
  }, [_vm._v("It ain’t necessarily so.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("         —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRA GERSHWIN")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725840fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 78
// module chunks = 0